function getDatesTranslatedByLanguage(userLanguage, estimatedDeliveryDates, userRegion) {
  const [minimum, maximum] = estimatedDeliveryDates.split('-').map(Number);
  
  const today = new Date();

  const minDate = new Date(today);
  minDate.setDate(today.getDate() + minimum);
  
  const maxDate = new Date(today);
  maxDate.setDate(today.getDate() + maximum);

  if(isSunday(minDate)) {
    minDate.setDate(minDate.getDate() + 1);
    
    if(minDate.getTime() === maxDate.getTime()) {
      maxDate.setDate(maxDate.getDate() + 1);
    }
  }

  if(isSunday(maxDate)) {
    maxDate.setDate(maxDate.getDate() + 1);
  }
  
  const optionsMin = { day: 'numeric' };
  const optionsMax = { day: 'numeric' };

  if(userLanguage == 'fr') {
    if (minDate.getMonth() == maxDate.getMonth()) {
      optionsMax.month = 'short';
    }
    else {
      optionsMin.month = 'short';
      optionsMax.month = 'short';
    }
  }
  else if(userLanguage == 'es') {
    if (minDate.getMonth() == maxDate.getMonth()) {
      optionsMax.month = 'long';
    }
    else {
      optionsMin.month = 'short';
      optionsMax.month = 'short';
    }
  }
  else if(userLanguage == 'de') {
    if (minDate.getMonth() == maxDate.getMonth()) {
      optionsMax.month = 'short';
    }
    else {
      optionsMin.month = 'short';
      optionsMax.month = 'short';
    }
  }
  else if(userLanguage == 'it') {
    if (minDate.getMonth() == maxDate.getMonth()) {
      optionsMax.month = 'long';
    }
    else {
      optionsMin.month = 'short';
      optionsMax.month = 'short';
    }
  }
  else if(userLanguage == 'nl') {
    if (minDate.getMonth() == maxDate.getMonth()) {
      optionsMax.month = 'short';
    }
    else {
      optionsMin.month = 'short';
      optionsMax.month = 'short';
    }
  }
  else
  {
    if (minDate.getMonth() == maxDate.getMonth()) {
    optionsMin.month = 'short';
    }
    else {
      optionsMin.month = 'short';
      optionsMax.month = 'short';
    }
  }

  const minDateFormatted = minDate.toLocaleDateString(userLanguage, optionsMin);
  const maxDateFormatted = maxDate.toLocaleDateString(userLanguage, optionsMax);

  if (userLanguage === 'fr') {
    return `Livraison prévue entre le <strong>${minDateFormatted}</strong> et le <strong>${maxDateFormatted}</strong>`;
  } else if (userLanguage === 'es') {
    return `Entrega estimada entre el <strong>${minDateFormatted}</strong> y el <strong>${maxDateFormatted}</strong>`;
  } else if (userLanguage === 'de') {
    return `Lieferung zwischen dem <strong>${minDateFormatted}</strong> und <strong>${maxDateFormatted}</strong>`;
  } else if (userLanguage === 'it') {
    return `Consegna prevista tra il <strong>${minDateFormatted}</strong> e il <strong>${maxDateFormatted}</strong>`;
  } else if (userLanguage === 'nl') {
    return `Verwachte levering tussen <strong>${minDateFormatted}</strong> en <strong>${maxDateFormatted}</strong>`;
  } else {
    return `Estimated delivery between <strong>${minDateFormatted}</strong> and <strong>${maxDateFormatted}</strong>`;
  }
}

function isSunday(date) {
  return date.getDay() === 0;
}

function getShippingOfferConditions(userLanguage, currencySymbol, shippingCost, offerAmount) {

  
  if (userLanguage === 'fr') {
    return `Frais d'expédition <strong>offerts</strong> dès ${offerAmount} ${currencySymbol} d'achat`;
  } else if (userLanguage === 'es') {
    return `Envío <strong>gratis</strong> a partir de ${offerAmount}${currencySymbol} de compra`;
  } else if (userLanguage === 'de') {
    return `<strong>Kostenloser Versand</strong> ab ${offerAmount}${currencySymbol}`;
  } else if (userLanguage === 'it') {
    return `<strong>Spedizione gratuita</strong> da ${offerAmount}${currencySymbol}`;
  } else if (userLanguage === 'nl') {
    return `<strong>Gratis verzending</strong> vanaf ${offerAmount}${currencySymbol}`;
  } else {
    let formattedShippingCost = shippingCost.replace(',', '.');
    let formattedOfferAmount = offerAmount.replace(',', '.');

    formattedShippingCost = formattedShippingCost.replace(' ', ',');
    formattedOfferAmount = formattedOfferAmount.replace(' ', ',');
    return `<strong>Free shipping</strong> on orders over ${currencySymbol}${offerAmount}`;
  }
}

function getShippingOfferBanner(userLanguage, countryInfo) {

  let currencySymbol = countryInfo.symbol;
  let offerAmount = countryInfo.offer;
  let countryFlag = countryInfo.flag;

  const imgSRC = 'https://cdn.shopify.com/s/files/1/0834/0389/9214/files/free-delivery-offer-banner.png?v=1740648465';
  
  if (userLanguage === 'fr') {
    return `Livraison <strong>offerte</strong> dès ${offerAmount} ${currencySymbol} d'achat ${countryFlag}`;
  } else if (userLanguage === 'es') {
    return `Envío <strong>gratis</strong> a partir de ${offerAmount}${currencySymbol} de compra ${countryFlag}`;
  } else if (userLanguage === 'de') {
    return `<strong>Kostenloser Versand</strong> ab ${offerAmount}${currencySymbol} ${countryFlag}`;
  } else if (userLanguage === 'it') {
    return `<strong>Spedizione gratuita</strong> da ${offerAmount}${currencySymbol} ${countryFlag}`;
  } else if (userLanguage === 'nl') {
    return `<strong>Gratis verzending</strong> vanaf ${offerAmount}${currencySymbol} ${countryFlag}`;
  } else {
    let formattedOfferAmount = offerAmount.replace(',', '.');

    formattedOfferAmount = formattedOfferAmount.replace(' ', ',');
    return `${countryFlag} <strong>Free shipping</strong> on orders over ${currencySymbol}${offerAmount} ${countryFlag}`;
  }
}

/*function getTranslation(key, lang) {
    return DYNAMIC_TRANSLATIONS[key]?.[lang] || DYNAMIC_TRANSLATIONS[key]?.["en"] || key;
}

const DYNAMIC_TRANSLATIONS = {
    temporary_cart: {
        fr: "Panier réservé jusqu'à minuit",
        es: "Carrito reservado hasta medianoche",
        en: "Cart reserved until midnight"
    },
    BAUHAUSPOSTERS5: {
        fr: "5% de remise bonus pour 2 affiches",
        es: "5% de descuento extra por 2 pósters",
        en: "5% extra discount for 2 posters"
    },
    BAUHAUSPOSTERS10: {
        fr: "10% de remise bonus pour 3 affiches",
        es: "10% de descuento extra por 3 pósters",
        en: "10% extra discount for 3 posters"
    },
};*/
